exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header[data-v-18e6451a] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--text-inactive, rgba(6, 38, 62, 0.64));\n  border-radius: 8px;\n  border: 1px solid rgba(6, 38, 62, 0.36);\n  background: var(--background-white, #fff);\n  box-shadow: 0px 4px 8px 0px rgba(6, 38, 62, 0.08);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  padding: 10px 15px;\n}\nheader p[data-v-18e6451a] {\n    margin-bottom: 0;\n}\n", ""]);

// exports
